import PropTypes from 'prop-types'

import { Span } from 'components'

type Props = ISpan & {
  type: PropertyType
}

export const PropertyType: React.FC<Props> = ({ type, ...style }) => {
  const propertyTypeMap = {
    'N/A': 'N/A',
    SINGLE_FAMILY_HOME: 'Single-family Home',
    MULTI_FAMILY_HOME: 'Multi-family Home',
    CONDOMINIUM: 'Condominium',
    APARTMENT: 'Apartment',
    MANUFACTURED_HOME: 'Mobile Home',
    TOWNHOUSE: 'Townhouse',
    STUDENT_HOUSING: 'Room/Dorm',
    OTHERS: 'Other',
  }
  return <Span {...style}>{propertyTypeMap[type]}</Span>
}
PropertyType.propTypes = {
  type: PropTypes.oneOf<PropertyType>([
    'N/A',
    'SINGLE_FAMILY_HOME',
    'MULTI_FAMILY_HOME',
    'CONDOMINIUM',
    'APARTMENT',
    'MANUFACTURED_HOME',
    'TOWNHOUSE',
    'STUDENT_HOUSING',
    'OTHERS',
  ]).isRequired,
}
